module.exports = __webpack_public_path__ + "static/media/support-icon.186f2edb.svg";